module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh_cn":{"productCategories":"拍品分类"},"zh_hk":{"productCategories":"拍品分類"},"en":{"productCategories":"Product Categories"},"ja":{"productCategories":"カテゴリ"}}')
  delete Component.options._Ctor
}
